// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"179":"3ed5d972","276":"3ed5d972","1206":"3ed5d972","1752":"cd036b20","2208":"d66aa9ad","3442":"3ed5d972","3524":"3ed5d972","4561":"3ed5d972","5542":"3ed5d972"}[chunkId] + ".chunk.css";
};